import { Controller } from "stimulus";
import { submitForm } from "init/ajax";

export default class extends Controller {

  connect() {
  }

  closeReviewModal(event) {
    event.preventDefault()

    document
      .querySelector('.ListingDetailReviews__modal-form')
      .classList
      .remove('ListingDetailReviews__activate-form')
  }

  openForm(event) {
    event.preventDefault()
    document.querySelector('.ListingDetailReviews__modal-form').classList.add('ListingDetailReviews__activate-form')
  }

  selectRate(event) {
    let radioValue = document.querySelector('input[name="review[rating]"]:checked').value;

    document.querySelectorAll('input[name="review[rating]"]').forEach((emptyStarElement) => {
      if (Number(radioValue) >= Number(emptyStarElement.value)) {
        emptyStarElement.setAttribute('style', 'background: url(/images/icons/star.svg) 50% no-repeat;')
      } else {
        emptyStarElement.setAttribute('style', 'background: url(/images/icons/blue-star.svg) 50% no-repeat;')
      }
    })
  }

  async submit(event) {
    event.preventDefault();

    const form = event.target;
    // Consider everything valid if browser validations aren't supported
    if (!form.reportValidity || form.reportValidity()) {
      await submitForm(form);

      document.querySelector('.ListingDetailReviews__modal-form').classList.remove('ListingDetailReviews__activate-form')

      document.querySelector('.ListingDetailReviews__container').classList.add('is-success')
    }
  }
}
